import { store } from '../../../../store';
import { asyncDailymotion } from './actions';

/**
 * react-mde command for the FR-only "Dailymotion" module. Opens the video
 * library modal; on pick, inserts the x6svc body-article iframe on its own line
 * at the caret. Mirrors FM/articles/embed/Command.
 */
export const getDailymotionCommand = () => ({
  name: 'dailymotion',
  keyCommand: 'dailymotion',
  execute: async (state0, api) => {
    const embedCode = await store.dispatch(asyncDailymotion());
    if (embedCode) {
      api.replaceSelection(`\n${embedCode}\n`);
    }
  },
});

/**
 * CodeMirror variant (mirrors getEmbedCommandInfo): opens the modal and returns
 * the text to insert, or null if cancelled. Used by the CodeMirror editor's
 * `dailymotion` command.
 */
export const getDailymotionCommandInfo = async () => {
  const embedCode = await store.dispatch(asyncDailymotion());
  if (!embedCode) {
    return null;
  }
  return { start: `\n${embedCode}\n` };
};
